
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"26","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#151515","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M2.393.98l22.628 22.628-1.414 1.414L.979 2.395z"}}),_c('path',{attrs:{"d":"M.98 23.607L23.609.979l1.414 1.414L2.395 25.021z"}})])])
          )
        }
      }
    